<div class="twenty-seven-page mt-20">
    <div class="">
        <div class="text-right">
            <img class="logo-img" src="assets/images/Header.png" />
        </div>
        <div class="mt-10">
            <div>
                <div class="text-center twenty-seven-page-Research">{{ data.dataMap.page26_29.child_title }}</div>
                <div class="twenty-seven-page-sec">
                    <div class="twenty-seven-page-Rsa-1">
                        {{ data.dataMap.page26_29.child_para }}
                        </div>
                </div>
            </div>
            <div class="clear-both"></div>
        </div>
        <div class="mt-20">
            <div>
                <div class="text-center twenty-seven-page-Research">{{ data.dataMap.page26_29.adult_title }}</div>
                <div class="twenty-seven-page-sec">
                    <div class="twenty-seven-page-Rsa-1">
                        {{ data.dataMap.page26_29.adult_para }}
                        </div>
                </div>
            </div>
            <div class="clear-both"></div>
        </div>
        <div class="mt-20">
            <div>
                <div class="text-center twenty-seven-page-Research">{{ data.dataMap.page26_29.friend_title }}</div>
                <div class="twenty-seven-page-sec">
                    <div class="twenty-seven-page-Rsa-1">
                        {{ data.dataMap.page26_29.friend_para }}
                        </div>
                </div>
            </div>
            <div class="clear-both"></div>
        </div>

    </div>
</div>